import type { FilterResetButtonProps } from './interfaces';
import styles from './FilterResetButton.module.scss';
import Icon from '../../Icon/Icon';

const FilterResetButton = ({ title, onClick }: FilterResetButtonProps) => {
  return (
    <div className={styles.base} onClick={onClick}>
      <Icon
        variant={'action/reset'}
        size="iconSize24"
        className={styles.icon}
      />{' '}
      <span className={styles.title}>{title}</span>
    </div>
  );
};

export default FilterResetButton;
